// extracted by mini-css-extract-plugin
module.exports = {"search-container":"search_search-container__lWLyu","filter-input":"search_filter-input__y_TQZ","search-area":"search_search-area__hAye2"};